import { render, staticRenderFns } from "./ScreenshotImageItem.vue?vue&type=template&id=66faf310&scoped=true&"
import script from "./ScreenshotImageItem.vue?vue&type=script&lang=js&"
export * from "./ScreenshotImageItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotImageItem.vue?vue&type=style&index=0&id=66faf310&prod&lang=scss&"
import style1 from "./ScreenshotImageItem.vue?vue&type=style&index=1&id=66faf310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66faf310",
  null
  
)

export default component.exports